//付款定义

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 类型
 */
class Type extends UltMeta {
    DOWNSTREAM_UPSTREAM = new Meta(1, "下游采购商-供应商");
    DOWNSTREAM_MIDSTREAM = new Meta(2, "下游采购商-联合采购商");
    MIDSTREAM_UPSTREAM = new Meta(3, "联合采购商-供应商");
}

export const TYPE = new Type();

/**
 * 付款方式
 */
class Mode extends UltMeta {
    CASH = new Meta(1, "现金");
    LETTER_OF_CREDIT = new Meta(2, "信用证");
    BANKER_ACCEPTANCE = new Meta(3, "银行承兑汇票");
    COMMERCIAL_ACCEPTANCE = new Meta(4, "商业承兑汇票");
    BANK_TRANSFER = new Meta(5, "银行转账");
}

export const MODE = new Mode();

/**
 * 状态
 */
class State extends UltMeta {
    CONFIRMING = new Meta(1, "确认中");
    FINISHED = new Meta(2, "已完成");
    REJECTED = new Meta(3, "已驳回");
    INVALIDING = new Meta(4, "作废中");
    INVALID = new Meta(5, "已作废");
}

export const STATE = new State();

class QueryType extends UltMeta {
    PAY_CUSTOMER = new Meta(1, "付款方");
    Collect_Customer = new Meta(2, "收款方");
}

export const QUERY_TYPE = new QueryType();
